<template>
  <div ref="card"
    class="global-search-results-card card mx-0 p-0"
    :class="{ 'po-match-card': isPoMatch, dark: $theme.isDark }">
    <div class="s-result">
      <div class="s-car image-container">
        <div v-if="isImageLoading"
          class="image-loading-spinner">
          <div class="spinner" />
        </div>

        <div v-else-if="!isVisible"
          class="image-lazy-placeholder">
          <span class="material-symbols-outlined lazy-icon">directions_car</span>
        </div>

        <img v-else
          class="quote-image"
          :class="{ 'no-image': !imageUrl || isPlaceholder }"
          :src="imageUrl || require('@/assets/images/placeholderGlobalSearch.svg')"
          @error="handleImageError"
          :style="{ opacity: isImageLoading ? 0 : 1 }">

        <span class="s-car-reg"
          v-html="getHighlightedText('regoNo', rego)" />
      </div>

      <div class="s-info">
        <div class="s-top">
          <span class="s-quote">
            <span class="s-quote-prefix">{{ displayReferencePrefix }}</span>
            <span v-html="displayReferenceNumber" />
          </span>
          <span v-if="!isInvoiceResult && !isPoResult"
            class="s-status"
            :class="jobStatusClass">{{ jobStatusText }}</span>
        </div>

        <div class="s-name has-tooltip-arrow"
          :data-tooltip="buildYear ? `${buildYear} ${makeModel}` : makeModel"
          v-html="(buildYear ? getHighlightedText('buildYear', buildYear) + ' ' : '') + getHighlightedText('makeModel', makeModel)" />

        <div v-if="!isPoResult && !isInvoiceResult"
          class="s-sub s-sub-customer-row">
          <span class="s-sub-item">
            <span class="s-lbl">Customer:</span>
            <span class="s-val s-val-customer"
              v-html="getHighlightedText('customer', customerName || '-')" />
          </span>
          <span v-if="phoneNo"
            class="s-sub-item">
            <span class="s-lbl">Ph:</span>
            <span class="s-val"
              v-html="getHighlightedText('phoneNo', phoneNo)" />
          </span>
        </div>

        <div v-if="!isPoResult && !isInvoiceResult"
          class="s-sub">
          <span class="s-sub-item">
            <span class="s-lbl">Colour:</span>
            <span class="s-val"
              v-html="getHighlightedText('colour', color || '-')" />
          </span>
          <span class="s-sub-item">
            <span class="s-lbl">Claim:</span>
            <span class="s-val"
              v-html="getHighlightedText('claimNo', claimNo || '-')" />
          </span>
        </div>

        <div v-if="!isPoResult && !isInvoiceResult"
          class="s-sub">
          <span class="s-sub-item">
            <span class="s-lbl">Insurer:</span>
            <span class="s-val"
              v-html="getHighlightedText('insurer', insurer || '-')" />
          </span>
          <span class="s-sub-item">
            <span class="s-lbl">Assessor:</span>
            <span class="s-val"
              v-html="getHighlightedText('assessorName', assessor || '-')" />
          </span>
        </div>

        <template v-if="isInvoiceResult">
          <div class="s-claim">
            <span class="s-lbl">Customer:</span>
            <span class="s-val"
              v-html="getHighlightedText('customer', customerName || '-')" />
            <span class="s-divider">|</span>
            <span class="s-lbl">Total:</span>
            <span class="s-val s-val-total">{{ formattedInvoiceTotal }}</span>
          </div>
          <div class="s-claim">
            <span class="s-lbl">Date:</span>
            <span class="s-val">{{ formattedInvoiceDate }}</span>
          </div>
        </template>

        <div v-else-if="isPoResult"
          class="s-claim">
          <span class="s-lbl">Supplier:</span>
          <span class="s-val"
            v-html="displaySupplier" />
        </div>
        <div v-if="isPoResult"
          class="s-claim">
          <span class="s-lbl">Date:</span>
          <span class="s-val">{{ primaryPoDate }}</span>
        </div>
      </div>
    </div>

    <!-- PO Match Section -->
    <!-- <div v-if="isPoMatch"
      class="po-match-section has-background-info-light p-2">
      <div class="is-flex is-align-items-center is-justify-content-space-between">
        <div class="is-flex is-align-items-center">
          <span class="has-text-weight-bold is-size-7 has-text-info"
            v-html="'PO Match: ' + getMatchedPoFieldsWithValues()" />
        </div>
        <button class="button is-small is-info is-outlined"
          @click="viewPo">
          View PO
        </button>
      </div>
    </div> -->
  </div>
</template>

<script>
import QuoteService from '../../views/quote/QuoteService'
import QuoteRoutes from '../../views/quote/route-types'

export default {
  name: 'GlobalSearchQuoteCard',
  props: {
    quoteId: {
      type: String,
      required: true
    },
    insurer: {
      type: String,
      required: true
    },
    quoteNumber: {
      type: String,
      required: true
    },
    resultType: {
      type: String,
      default: ''
    },
    pos: {
      type: Array,
      default: () => []
    },
    invoices: {
      type: Array,
      default: () => []
    },
    buildYear: {
      type: String,
      default: ''
    },
    makeModel: {
      type: String,
      required: true
      // default: 'DefaultMake'
    },
    rego: {
      type: String,
      required: true
    },
    claimNo: {
      type: String,
      required: false
    },
    color: null,
    cost: {
      type: Number // Or Number, if you prefer to format it
    },
    customerName: {
      type: String
    },
    highLight: {
      type: Object,
      default: () => ({})
    },
    phoneNo: {
      type: String,
      default: ''
    },
    assessor: {
      type: String,
      default: ''
    },
    jobStage: {
      type: Number,
      default: 0 // Default to 0 if not provided}
    },
    jobStagesSubStages: {
      type: Array,
      default: () => []
    },
    orderStatus: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      imageUrl: null,
      hasImage: false,
      isPlaceholder: false,
      isImageLoading: false,
      isVisible: false,
      observer: null
    }
  },

  computed: {
    routeTypes() {
      return QuoteRoutes
    },
    formattedCost() {
      const amount = Number(this.cost)
      if (Number.isNaN(amount)) {
        return '$0.00'
      }
      return `$${amount.toFixed(2)}`
    },
    primaryInvoice() {
      if (!this.invoices || !this.invoices.length) return null
      // Find the invoice entry that had a highlight match
      const invoicesHighlight = this.highLight && this.highLight['invoices']
      if (Array.isArray(invoicesHighlight)) {
        const matchedIndex = invoicesHighlight.findIndex((item) => {
          const f = item['no']
          return f && (
            (f.matched_tokens && f.matched_tokens.length > 0) ||
            (f.snippet && f.snippet.includes('<em>')) ||
            (f.value && f.value.includes('<em>'))
          )
        })
        if (matchedIndex !== -1 && this.invoices[matchedIndex]) {
          return this.invoices[matchedIndex]
        }
      }
      return this.invoices[0]
    },
    formattedInvoiceTotal() {
      const inv = this.primaryInvoice
      const amount = Number(inv && inv.totalAmount)
      if (Number.isNaN(amount) || !inv) return '-'
      return `$${amount.toFixed(2)}`
    },
    formattedInvoiceDate() {
      return this.formatDate(this.primaryInvoice && this.primaryInvoice.date)
    },
    jobStatusText() {
      // Use the jobStagesSubStages prop if available
      if (this.jobStagesSubStages && this.jobStagesSubStages.length > 0) {
        const matchingStage = this.jobStagesSubStages.find((stage) => stage.jobStageId === this.jobStage)
        if (matchingStage) {
          return matchingStage.compositeName.trim()
        }
      }
      return 'Unknown'
    },
    jobStatusClass() {
      const status = (this.jobStatusText || '').toLowerCase()
      if (status.includes('close') || status.includes('cancel')) {
        return 'st-closed'
      }
      if (status.includes('pending') || status.includes('await') || status.includes('hold')) {
        return 'st-pending'
      }
      return 'st-open'
    },
    poStatusText() {
      return this.orderStatus || 'Unknown'
    },
    primaryPoField() {
      const first = this.pos && this.pos[0]
      if (!first) return null
      if (first.no && first.no.trim()) return 'no'
      if (first.pcNo && first.pcNo.trim()) return 'pcNo'
      return null
    },
    primaryPoNumber() {
      const first = this.pos && this.pos[0]
      if (!first) return ''
      return (first.no && first.no.trim()) || (first.pcNo && first.pcNo.trim()) || ''
    },
    primarySupplier() {
      const first = this.pos && this.pos[0]
      return (first && first.vendor && first.vendor.trim()) || '-'
    },
    primaryPoDate() {
      const first = this.pos && this.pos[0]
      return this.formatDate(first && first.date)
    },
    hasPoHighlightMatch() {
      if (!this.highLight) return false
      const posHighlights = this.highLight['pos']
      if (!Array.isArray(posHighlights)) return false
      return posHighlights.some((item) =>
        ['no', 'pcNo', 'vendor'].some((subField) => {
          const f = item[subField]
          return f && (
            (f.matched_tokens && f.matched_tokens.length > 0) ||
            (f.snippet && f.snippet.includes('<em>')) ||
            (f.value && f.value.includes('<em>'))
          )
        })
      )
    },
    isPoResult() {
      if (this.resultType) return this.resultType === 'po'
      return this.hasPoHighlightMatch || (this.pos && this.pos.length > 0)
    },
    hasInvoiceHighlightMatch() {
      if (!this.highLight) return false
      const invoicesHighlight = this.highLight['invoices']
      if (!Array.isArray(invoicesHighlight)) return false
      return invoicesHighlight.some((item) => {
        const f = item['no']
        return f && (
          (f.matched_tokens && f.matched_tokens.length > 0) ||
          (f.snippet && f.snippet.includes('<em>')) ||
          (f.value && f.value.includes('<em>'))
        )
      })
    },
    isInvoiceResult() {
      if (this.resultType) return this.resultType === 'invoice'
      return this.hasInvoiceHighlightMatch || (this.invoices && this.invoices.length > 0)
    },
    primaryInvoiceNumber() {
      return (this.primaryInvoice && this.primaryInvoice.no && this.primaryInvoice.no.trim()) || ''
    },
    displayReferencePrefix() {
      if (this.isInvoiceResult) return '#'
      if (this.isPoResult) return '#'
      return '#'
    },
    displayReferenceNumber() {
      if (this.isInvoiceResult && this.primaryInvoiceNumber) {
        const invoicesHighlight = this.highLight && this.highLight['invoices']
        if (Array.isArray(invoicesHighlight)) {
          const f = invoicesHighlight[0] && invoicesHighlight[0]['no']
          if (f) {
            if (f.snippet && f.snippet.includes('<em>')) return f.snippet.replace(/<em>/g, '<span class="highlight">').replace(/<\/em>/g, '</span>')
            if (f.value && f.value.includes('<em>')) return f.value.replace(/<em>/g, '<span class="highlight">').replace(/<\/em>/g, '</span>')
            if (f.matched_tokens && f.matched_tokens.length > 0) {
              let highlighted = this.primaryInvoiceNumber
              f.matched_tokens.forEach((token) => {
                highlighted = highlighted.replace(new RegExp(`(${token})`, 'gi'), '<span class="highlight">$1</span>')
              })
              return highlighted
            }
          }
        }
        return this.primaryInvoiceNumber
      }
      if (this.isPoResult && this.primaryPoNumber) {
        const subField = (this.pos && this.pos[0] && this.pos[0].no && this.pos[0].no.trim()) ? 'no' : 'pcNo'
        const posHighlights = this.highLight && this.highLight['pos']
        if (Array.isArray(posHighlights)) {
          for (const item of posHighlights) {
            const f = item[subField]
            if (!f) continue
            if (f.snippet && f.snippet.includes('<em>')) return f.snippet.replace(/<em>/g, '<span class="highlight">').replace(/<\/em>/g, '</span>')
            if (f.value && f.value.includes('<em>')) return f.value.replace(/<em>/g, '<span class="highlight">').replace(/<\/em>/g, '</span>')
            if (f.matched_tokens && f.matched_tokens.length > 0) {
              let highlighted = this.primaryPoNumber.toString()
              f.matched_tokens.forEach((token) => {
                highlighted = highlighted.replace(new RegExp(`(${token})`, 'gi'), '<span class="highlight">$1</span>')
              })
              return highlighted
            }
          }
        }
        return this.primaryPoNumber
      }
      return this.getHighlightedText('quoteNo', this.quoteNumber)
    },
    displaySupplier() {
      const fallback = this.primarySupplier
      const posHighlights = this.highLight && this.highLight['pos']
      if (Array.isArray(posHighlights)) {
        for (const item of posHighlights) {
          const f = item['vendor']
          if (!f) continue
          if (f.snippet && f.snippet.includes('<em>')) return f.snippet.replace(/<em>/g, '<span class="highlight">').replace(/<\/em>/g, '</span>')
          if (f.value && f.value.includes('<em>')) return f.value.replace(/<em>/g, '<span class="highlight">').replace(/<\/em>/g, '</span>')
          if (f.matched_tokens && f.matched_tokens.length > 0) {
            let highlighted = fallback.toString()
            f.matched_tokens.forEach((token) => {
              highlighted = highlighted.replace(new RegExp(`(${token})`, 'gi'), '<span class="highlight">$1</span>')
            })
            return highlighted
          }
        }
      }
      return fallback
    },
    isPoMatch() {
      return this.hasPoHighlightMatch
    }
  },

  watch: {
    quoteId: {
      handler(newQuoteId) {
        if (newQuoteId && this.isVisible) {
          this.getQuoteImage(newQuoteId)
        }
      },
      immediate: false
    }
  },

  mounted() {
    this.setupLazyLoading()
  },

  beforeDestroy() {
    if (this.observer) {
      this.observer.disconnect()
    }
  },

  methods: {
    firstValue(val) {
      if (Array.isArray(val)) {
        const firstNonEmpty = val.find((item) => typeof item === 'string' && item.trim().length > 0)
        return firstNonEmpty || ''
      }
      if (typeof val === 'string') {
        return val.trim()
      }
      return ''
    },
    hasValue(val) {
      if (val === null || val === undefined) return false
      if (Array.isArray(val)) return val.some((item) => (typeof item === 'string' ? item.trim().length > 0 : Boolean(item)))
      if (typeof val === 'string') return val.trim().length > 0
      if (typeof val === 'object') return Object.keys(val).length > 0
      return Boolean(val)
    },
    setupLazyLoading() {
      // Check if Intersection Observer is supported
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting && !this.isVisible) {
                this.isVisible = true
                this.loadImage()
                // Disconnect observer once image is visible
                this.observer.disconnect()
              }
            })
          },
          {
            root: null,
            rootMargin: '50px', // Load image 50px before it becomes visible
            threshold: 0.1
          }
        )

        // Observe the component element
        this.$nextTick(() => {
          const el = this.$refs.card
          if (el instanceof Element) {
            this.observer.observe(el)
          } else {
            this.isVisible = true
            this.loadImage()
          }
        })
      } else {
        // Fallback for browsers that don't support Intersection Observer
        this.isVisible = true
        this.loadImage()
      }
    },

    loadImage() {
      if (this.quoteId && !this.imageUrl) {
        this.getQuoteImage(this.quoteId)
      }
    },

    formatDate(dateString) {
      if (!dateString) return '-'
      const date = new Date(dateString)
      if (Number.isNaN(date.getTime())) return '-'
      const day = date.getDate().toString().padStart(2, '0')
      const month = (date.getMonth() + 1).toString().padStart(2, '0')
      const year = date.getFullYear()
      return `${day}/${month}/${year}`
    },
    async getQuoteImage(quoteId) {
      this.isImageLoading = true
      try {
        const response = await QuoteService.getQuoteThumbnailImage(quoteId)

        if (!response) {
          console.warn('No image response received for quote:', quoteId)
          this.imageUrl = require('@/assets/images/placeholderGlobalSearch.svg') // Fallback image
          this.isPlaceholder = true
          this.isImageLoading = false
          return
        }

        // Check if response is a base64 data URL
        if (response && typeof response === 'string' && response.startsWith('data:')) {
          this.imageUrl = response
          this.isPlaceholder = false
          this.isImageLoading = false // Set loading to false after image is set
          return
        }
      } catch (error) {
        console.error('Error fetching quote image:', error)
        this.imageUrl = require('@/assets/images/placeholderGlobalSearch.svg') // Fallback image
        this.isPlaceholder = true
        this.isImageLoading = false
      }
    },

    handleImageError() {
      this.imageUrl = require('@/assets/images/placeholderGlobalSearch.svg')
      this.isPlaceholder = true
    },
    getPosHighlightedText(subField, fallbackValue) {
      const posHighlights = this.highLight && this.highLight['pos']
      if (!Array.isArray(posHighlights) || !fallbackValue) return fallbackValue
      for (const item of posHighlights) {
        const f = item[subField]
        if (!f) continue
        if (f.snippet && f.snippet.includes('<em>')) {
          return f.snippet.replace(/<em>/g, '<span class="highlight">').replace(/<\/em>/g, '</span>')
        }
        if (f.value && f.value.includes('<em>')) {
          return f.value.replace(/<em>/g, '<span class="highlight">').replace(/<\/em>/g, '</span>')
        }
        if (f.matched_tokens && f.matched_tokens.length > 0) {
          let highlighted = fallbackValue.toString()
          f.matched_tokens.forEach((token) => {
            const regex = new RegExp(`(${token})`, 'gi')
            highlighted = highlighted.replace(regex, '<span class="highlight">$1</span>')
          })
          return highlighted
        }
      }
      return fallbackValue
    },
    getHighlightedText(key, value) {
      // Check if we have highlight data for this field
      if (!this.highLight || !this.highLight[key] || !value) {
        return value
      }
      const highlightData = this.highLight[key]

      // Handle array format (new format)
      if (Array.isArray(highlightData)) {
        // Find the first item with highlights
        for (const item of highlightData) {
          // snippet is used by Typesense for nested array-of-object fields
          if (item.snippet && item.snippet.includes('<em>')) {
            return item.snippet.replace(/<em>/g, '<span class="highlight">').replace(/<\/em>/g, '</span>')
          }

          // value with <em> tags (flat fields)
          if (item.value && item.value.includes('<em>')) {
            return item.value.replace(/<em>/g, '<span class="highlight">').replace(/<\/em>/g, '</span>')
          }

          // If there are matched tokens, highlight them manually
          if (item.matched_tokens && item.matched_tokens.length > 0) {
            let highlightedValue = value.toString()
            const tokens = item.matched_tokens.flat()
            tokens.forEach((token) => {
              const regex = new RegExp(`(${token})`, 'gi')
              highlightedValue = highlightedValue.replace(regex, '<span class="highlight">$1</span>')
            })
            return highlightedValue
          }
        }

        // Return original value if no highlights found in array
        return value
      }

      // Handle object format (legacy format)
      // If there's already highlighted content with <em> tags, use it
      if (highlightData.value && highlightData.value.includes('<em>')) {
        return highlightData.value.replace(/<em>/g, '<span class="highlight">').replace(/<\/em>/g, '</span>')
      }

      // If there are matched words, highlight them
      if (highlightData.matchedWords && highlightData.matchedWords.length > 0) {
        let highlightedValue = value.toString()
        highlightData.matchedWords.forEach((word) => {
          const regex = new RegExp(`(${word})`, 'gi')
          highlightedValue = highlightedValue.replace(regex, '<span class="highlight">$1</span>')
        })
        return highlightedValue
      }

      // Return original value if no highlights
      return value
    },

    getMatchedPoFields() {
      if (!this.pos || !this.pos.length) return ''
      const parts = []
      const first = this.pos[0]
      if (first.no) parts.push('PO Number')
      if (first.pcNo) parts.push('PC PO Number')
      if (first.vendor) parts.push('Vendor')
      return parts.join(', ') + ' matched'
    },

    getMatchedPoFieldsWithValues() {
      if (!this.pos || !this.pos.length) return ''
      const first = this.pos[0]
      if (first.vendor) return `Vendor. ${first.vendor}`
      if (first.no) return `PO. ${first.no}`
      if (first.pcNo) return `PartsCheck PO. ${first.pcNo}`
      return ''
    },

    viewPo(e) {
      e.stopPropagation()
      this.$router.push(`/quotes/${this.quoteId}/partscontrol`)
    }
  }
}
</script>

<style lang="scss">
// Light mode defaults
.global-search-results-card {
  --s-card-bg:       #ffffff;
  --s-card-bg-hover: #f3f4f6;
  --s-card-border:   #d1d5db;
  --s-card-img-bg:   #e5e7eb;
  --s-card-reg-bg:   #f3f4f6;
  --s-card-text:     #111827;
  --s-card-label:    #6b7280;
  --s-card-divider:  #9ca3af;

  background: var(--s-card-bg);
  border: 1px solid var(--s-card-border);
  border-radius: 8px;
  overflow: hidden;
  cursor: pointer;
  transition: background-color 0.12s ease-in-out;

  &:hover {
    background: var(--s-card-bg-hover);
  }

  .highlight {
    padding: 1px 2px;
    border-radius: 2px;
    background-color: #4a9eff;
    color: #ffffff;
  }

  .highlight.po-match {
    background-color: #facc15;
    color: #000000;
  }
}

// Dark mode — driven by .theme-dark on <html> (same mechanism as _dark.scss)
.theme-dark .global-search-results-card {
  --s-card-bg:       #2b333b;
  --s-card-bg-hover: #374151;
  --s-card-border:   #4c5967;
  --s-card-img-bg:   #16191d;
  --s-card-reg-bg:   #16191d;
  --s-card-text:     #ffffff;
  --s-card-label:    #9ca3af;
  --s-card-divider:  #6b7280;

  .highlight {
    background-color: #1d4ed8;
    color: #93c5fd;
  }
}
</style>

<style lang="scss" scoped>
.image-container {
  position: relative;
  width: 110px;
  min-height: 100px;
  border-radius: 6px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  background: var(--s-card-img-bg);
  border: 1px solid var(--s-card-border);
  flex-shrink: 0;

  .image-loading-spinner {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 5;

    .spinner {
      width: 28px;
      height: 28px;
      border-top: 3px solid #3273dc;
      border-radius: 50%;
      animation: spin 1s linear infinite;
    }
  }

  .image-lazy-placeholder {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;

    z-index: 5;

    .lazy-icon {
      font-size: 30px;
      opacity: 0.5;
      color: #627384;
    }
  }

  .quote-image {
    width: 100%;
    height: 70px;
    object-fit: cover;
    object-position: center;
    display: block;
    transition: opacity 0.3s ease;

    &.no-image {
      opacity: 0.4;
      width: 64px !important;
      height: 64px !important;
      object-fit: contain !important;
      position: absolute;
      top: 35px;
      left: 50%;
      transform: translate(-50%, -50%);
      border-radius: 0;
    }
  }

  .s-car-reg {
    position: relative;
    z-index: 10;
    width: 100%;
    text-align: center;
    padding: 6px 4px;
    color: var(--s-card-label);
    font-size: 11px;
    font-weight: 600;
    letter-spacing: 0.5px;
    text-transform: uppercase;
    background: var(--s-card-reg-bg);
  }
}

.cost-display {
  color: #f59e0b;
  font-weight: 700;
}

.global-search-results-card {
  .s-result {
    display: flex;
    align-items: stretch;
    gap: 14px;
    padding: 12px 16px;
  }

  .s-info {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 5px;
    min-width: 0;
  }

  .s-top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 8px;
  }

  .s-quote {
    color: var(--s-card-label);
    font-size: 12px;
    font-weight: 600;
  }

  .s-status {
    font-size: 11px;
    font-weight: 700;
    padding: 2px 8px;
    border-radius: 3px;
    white-space: nowrap;
  }

  .st-open {
    background: #166534;
    color: #86efac;
  }

  .st-closed {
    background: #7c2d12;
    color: #fca5a5;
  }

  .st-pending {
    background: #854d0e;
    color: #fde68a;
  }

  .s-name {
    color: var(--s-card-text);
    font-size: 14px;
    font-weight: 600;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .s-sub {
    color: var(--s-card-text);
    font-size: 12px;
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
  }

  .s-sub-customer-row {
    flex-wrap: nowrap;
    justify-content: flex-start;
    align-items: center;
    gap: 6px;
  }

  .s-sub-item {
    display: inline-flex;
    align-items: baseline;
    gap: 4px;
    min-width: 0;
  }

  .s-lbl {
    color: var(--s-card-label);
    white-space: nowrap;
  }

  .s-val {
    color: var(--s-card-text);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 180px;
  }

  .s-val-customer {
    max-width: 230px;
  }

  .s-val-total {
    color: #f59e0b;
    font-weight: 700;
  }

  .s-claim {
    color: var(--s-card-text);
    font-size: 11px;
    display: flex;
    align-items: center;
    gap: 5px;
    min-width: 0;
    flex-wrap: wrap;
  }

  .s-divider {
    color: var(--s-card-divider);
  }

  .po-match-section {
    border-top: 1px solid #4c5967;
    background: #1f2937;
    padding: 8px 12px;
  }

  .po-match-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
  }

  .po-match-text {
    color: #93c5fd;
    font-size: 12px;
    font-weight: 700;
  }
}

.dropdown-item {
  &.is-hovered {
    .global-search-results-card {
      box-shadow: unset !important;
      border: 1px solid var(--s-card-divider);
      background: var(--s-card-bg-hover) !important;
    }
  }
}

.global-search-results-card {
  img {
    max-height: unset !important;
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
